<template>
    <div class="content w-full flex flex-col px-5 pt-16 justify-center pb-10">
        <LoadingDialog v-if="actionBeingPerformed" />
        <ConfirmationModal v-if="askConfirmation" :title="confirmationTitle" :text="confirmationText"
            @emitResponse="checkConfirmationResponse" />
        <div class="w-full justify-center flex flex-wrap px-3 mx-10">
            <div class="w-full text-left mb-5">
                <Button :label="'Novo curso'" class="no-bg-button" severity="info" @click.prevent="openSaveCourse()" />
            </div>
            <div v-if="loadingCourse" class="py-3">
                <LoaderComponent />
            </div>
            <div class="w-full md:w-3/4 lg:w-3/4" v-if="!loadingCourse && myCourses && myCourses.length > 0">
                <Carousel :value="myCourses" :numVisible="getVisibleCarrouselPage()" v-if="myCourses.length >= 3">
                    <template #item="slotProps">
                        <div class="shadow border-surface-200 dark:border-surface-700 rounded m-2 p-4 w-auto h-full"
                            :class="selectedCard == slotProps.data.uuid ? 'selected-card' : ''">
                            <div class="mb-4">
                                <CoursePhotoComponent :course="slotProps.data" />
                            </div>
                            <div class="mb-4 font-medium">{{ slotProps.data.title }}</div>
                            <div class="flex justify-end">
                                <Button icon="pi pi-pen-to-square" severity="info" class="ml-2 no-bg-button"
                                    @click.prevent.stop="openSaveCourse(slotProps.data.uuid)" />
                                <Button icon="pi pi-trash" class="ml-2" severity="secondary"
                                    @click.prevent.stop="openConfirmationModal('removeCourse', slotProps.data.uuid)" />
                            </div>
                        </div>
                    </template>
                </Carousel>

                <div class="flex flex-wrap -m-2" v-if="myCourses.length < 3">
                    <div v-for="course in myCourses" :key="course.uuid" class="p-2 w-full sm:w-1/2 lg:w-1/3">
                        <div class="shadow border-surface-200 dark:border-surface-700 rounded p-4 w-full h-full"
                            :class="selectedCard == course.uuid ? 'selected-card' : ''">
                            <div class="mb-4">
                                <CoursePhotoComponent :course="course" />
                            </div>
                            <div class="mb-4 font-medium">{{ course.title }}</div>
                            <div class="flex justify-end">
                                <Button icon="pi pi-pen-to-square" severity="info" class="ml-2 no-bg-button"
                                    @click.prevent.stop="openSaveCourse(course.uuid)" />
                                <!-- <Button icon="pi pi-trash" class="ml-2" severity="secondary"
                                    @click.prevent.stop="openConfirmationModal('removeCourse', course.uuid)" /> -->
                            </div>
                        </div>
                    </div>
                </div>

                <div v-if="myCourses.length == 0" class="w-full text-center py-10">
                    <p class="text-lg text-surface-500 dark:text-surface-400">Nenhum curso encontrado. Que tal criar um
                        novo?</p>
                </div>

            </div>
        </div>

        <template v-if="openEditTab">
            <div class="py-10 px-3 mx-10">
                <div class="text-right relative" style="margin-bottom: -25px; z-index: 100;">
                    <i class="pi pi-times cursor-pointer" @click="openEditTab = false; selectedCard = null"></i>
                </div>
                <Tabs :value="actionBeingExecuted">
                    <TabList>
                        <Tab v-for="tab in items" :key="tab.name" :value="tab.id" @click="openData(tab.id)">
                            <a v-ripple :href="href" class="flex items-center gap-2 text-inherit"
                                v-if="checkIfCanShowMenuTab(tab.id)">
                                <i :class="tab.icon" />
                                <span>{{ translate(tab.label, 'ucfirst') }}</span>
                            </a>
                        </Tab>
                    </TabList>
                </Tabs>
            </div>
            <SaveCourseForm v-if="actionBeingExecuted == 'course_save'"
                @actionPerformed="listCourses('course_save', true)" :courseData="courseData"
                :class="'card shadow-lg py-10 px-3 mx-10'" />

            <SaveCategoryForm v-if="actionBeingExecuted == 'category_save'" @actionPerformed="listCategories()"
                :categoryData="courseData.categoryData" :courseUuid="courseData.uuid"
                :class="'card shadow-lg py-10 px-3 mx-10'" />

            <ModulesComponent v-if="actionBeingExecuted == 'course_module_save'" :courseUuid="courseData.uuid"
                @moduleSelected="showModuleVideos" :class="'card shadow-lg py-10 px-3 mx-10'" />

            <ModulesVideosComponent v-if="actionBeingExecuted == 'course_module_video_save'"
                :moduleData="selectedModuleForVideo" @lessonsSelected="showModuleVideoLessons"
                :class="'card shadow-lg py-10 px-3 mx-10'" />

            <ModuleVideosLessonsComponent v-if="actionBeingExecuted == 'course_module_video_lesson_save'"
                :videoData="corseModuleVideoData" :class="'card shadow-lg py-10 px-3 mx-10'" />
        </template>
    </div>
</template>
<script setup>
import { onMounted, ref, toRaw } from 'vue';
import Button from 'primevue/button';
import Carousel from 'primevue/carousel';
import { getBase64 } from '@/composables/imageChecker';
import LoaderComponent from '@/components/Utils/LoaderComponent.vue';
import { showToast } from '@/composables/toast';
import { useToast } from 'primevue/usetoast';
import SaveCourseForm from '@/components/Dashboard/Course/saveFormComponent.vue';
import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import { translate } from '@/composables/translate';
import LoadingDialog from '@/components/Utils/LoadingDialog.vue';
import ConfirmationModal from '@/components/Utils/ConfirmationModal.vue';
import ModulesComponent from '@/components/Dashboard/Course/ModulesComponent.vue';
import ModulesVideosComponent from '@/components/Dashboard/Course/ModulesVideosComponent.vue';
import ModuleVideosLessonsComponent from '@/components/Dashboard/Course/ModuleVideosLessonsComponent.vue';
import CourseService from '@/services/CourseService';
import CoursePhotoComponent from '@/components/Course/CoursePhotoComponent.vue';
import SaveCategoryForm from '@/components/Dashboard/Course/SaveCategoryForm.vue';
import CategoryService from '@/services/CategoryService';
import LanguageService from '@/services/LanguageService';

const toast = useToast();
let askConfirmation = ref(false);
let actionBeingPerformed = ref(false);
let actionBeingExecuted = ref('course_save');
let loadingCourse = ref(true);
let myCourses = ref([]);
let coursesByUuid = ref({});
let openEditTab = ref(false);

const items = ref([
    { name: 'course', label: 'course', icon: 'pi pi-book', id: 'course_save' },
    { name: 'category', label: 'category', icon: 'pi pi-tag', id: 'category_save' },
    { name: 'module', label: 'module', icon: 'pi pi-table', id: 'course_module_save' },
    { name: 'video', label: 'videos', icon: 'pi pi-video', id: 'course_module_video_save' },
    { name: 'lesson', label: 'lessons', icon: 'pi pi-file', id: 'course_module_video_lesson_save' },
]);

onMounted(() => {
    listCourses();
    listLanguages();
});

let selectedCard = ref(null);
let languagesData = ref({
    data: [],
    loading: true
});

async function listLanguages() {
    languagesData.value.loading = true;
    const response = LanguageService.getLanguages();

    languagesData.value.data = [];
    languagesData.value.data = response.parsedItems();
    
    languagesData.value.loading = false;
}

async function listCourses(selecMenu = null) {
    if (loadingCourse.value && myCourses.value.length > 0) return;

    loadingCourse.value = true;
    let parsedCourses = [];
    const coursesList = await CourseService.getAdminCourses();

    coursesByUuid.value = {};
    for (let course of coursesList) {
        let thisData = course;
        thisData['hasCoursePhoto'] = thisData['coursePhoto'] == null ? false : true;
        thisData['hasCourseCoverPhoto'] = thisData['courseCoverPhoto'] == null ? false : true;
        thisData['coursePhoto'] = await getBase64(thisData['coursePhoto'], true);
        thisData['courseCoverPhoto'] = await getBase64(thisData['courseCoverPhoto'], true);
        parsedCourses.push(thisData);
        coursesByUuid.value[thisData.uuid] = thisData;
    }

    myCourses.value = parsedCourses;
    loadingCourse.value = false;
    if (selecMenu != null)
        actionBeingExecuted.value = selecMenu;
}

let courseData = ref({
    uuid: null,
    title: null,
    description: null,
    timeInMinutes: null,
    courseLanguage: null,
    teachedLanguage: null,
    coursePhoto: null,
    price: null,
    categoryData: null,
    active: true
});

async function openSaveCourse(uuid = '') {
    if (uuid != '') {
        if (coursesByUuid.value[uuid] == undefined) {
            showToast(toast, 'course not found', 'error');
            return;
        }
        // CORREÇÃO: Clona os dados para que edições no formulário não quebrem as referências do Carrossel instantaneamente
        const data = JSON.parse(JSON.stringify(coursesByUuid.value[uuid]));
        courseData.value = {
            uuid: data.uuid,
            title: data.title,
            description: data.description,
            timeInMinutes: data.timeInMinutes,
            courseLanguage: data.courseLanguage,
            teachedLanguage: data.teachedLanguage,
            coursePhoto: data.hasCoursePhoto ? data.coursePhoto : null,
            price: data.price,
            active: data.active
        }
        await listCategories();
    } else {
        resetCourseData();
    }
    openEditTab.value = true;
    selectedCard.value = uuid;
    actionBeingExecuted.value = 'course_save';
    showModuleTab.value = true;
    selectedModuleForVideo.value = null;
    openData('course_save');
}

async function listCategories() {
    if (!courseData.value.uuid) return;
    const categories = await CategoryService.getByCourse(courseData.value.uuid);
    courseData.value.categoryData = categories;
}

let selectedModuleForVideo = ref(null);
function showModuleVideos(event) {
    if (event && typeof event === 'object') {
        // CORREÇÃO: Passa uma cópia profunda limpa de reatividade nativa para o filho.
        // Isso impede que o 'watch' profundo do filho detecte mutações internas durante o ciclo de vida do componente pai.
        selectedModuleForVideo.value = JSON.parse(JSON.stringify(toRaw(event)));
        openData('course_module_video_save');
    }
}

let showModuleTab = ref(false)
const avaliableDatas = ['course_save', 'category_save', 'course_module_save', 'course_module_video_save', 'course_module_video_lesson_save'];
function openData(formName = '') {
    let val = formName;
    if (!avaliableDatas.includes(formName))
        val = avaliableDatas[0];
    showModuleTab.value = (courseData.value && courseData.value.uuid) ? true : false;
    actionBeingExecuted.value = val;
}

function resetCourseData() {
    courseData.value = {
        uuid: null,
        title: null,
        description: null,
        timeInMinutes: null,
        courseLanguage: null,
        teachedLanguage: null,
        coursePhoto: null,
        price: null,
        active: 1
    }
}

async function removeCourse(uuid = '') {
    if (actionBeingPerformed.value) return;
    actionBeingPerformed.value = true;
    const response = await CourseService.removeCourse(uuid);
    actionBeingPerformed.value = false;
    if (!response.success()) {
        showToast(toast, response.getMessage(), 'error');
        return;
    }
    showToast(toast, response.getMessage());
    listCourses(null);
}

let selectedConfirmation = ref('');
let confirmationMethodVariable = ref('');
let confirmationTitle = ref('');
let confirmationText = ref('');
let confirmationModalValues = ref({
    removeCourse: {
        title: 'Are you sure you wish to remove this course?',
        text: 'this action can not be undone'
    }
})
function openConfirmationModal(action = 'removeCourse', identifier = '') {
    confirmationTitle.value = confirmationModalValues.value[action].title;
    confirmationText.value = confirmationModalValues.value[action].text;
    selectedConfirmation.value = action;
    confirmationMethodVariable.value = identifier;
    askConfirmation.value = true;
}
function checkConfirmationResponse(value) {
    if ([null, undefined].includes(value))
        return;
    const confirmation = value.confirmation;
    askConfirmation.value = false;
    if (confirmation) {
        switch (selectedConfirmation.value) {
            case 'removeCourse':
                removeCourse(confirmationMethodVariable.value);
                break;
        }
    }
}

function checkIfCanShowMenuTab(tabId = '') {
    let response = false;
    switch (tabId) {
        case 'course_save':
        case 'category_save':
            response = true;
            break;
        case 'course_module_save':
            response = showModuleTab.value;
            break;
        case 'course_module_video_save':
            response = selectedModuleForVideo.value !== null;
            break;
        case 'course_module_video_lesson_save':
            response = corseModuleVideoData.value !== null;
            break;
    }
    return response;
}

let corseModuleVideoData = ref(null);
function showModuleVideoLessons(id) {
    // CORREÇÃO: Isolamento completo de estado enviado para as aulas do vídeo
    corseModuleVideoData.value = JSON.parse(JSON.stringify(toRaw(id)));
    openData('course_module_video_lesson_save');
}

function getVisibleCarrouselPage() {
    return 4;
}
</script>
<style scoped>
.selected-card {
    background-color: var(--cream) !important;
    transition: 0.5s ease;
}

.selected-card .edit-course-btn {
    opacity: 0;
    pointer-events: none !important;
    cursor: none !important;
}
</style>